<template>
  <div class="px-4">
    <p class="font-bold">{{skill}} - {{ level }}</p>
    <div class="level-progress-bar">
      <div :style="{ width: percentage+'%'}">
        <div>
          <span>{{percentage}}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSkillItem',
  props: {
    skill: { type: String },
    percentage: { type: Number }
  },
  computed: {
    level () {
      if (this.percentage < 50) return this.$t('homepage.skill-levels.beginner')
      else if (this.percentage < 90) return this.$t('homepage.skill-levels.intermediate')
      else return this.$t('homepage.skill-levels.expert')
    }
  }
}
</script>

<style scoped>
@keyframes fill-bar-animation {
  from { width: 0; }
  to { width: 100%; }
}
.level-progress-bar {
  @apply w-full border border-black rounded-sm;
}
.level-progress-bar> div > div {
  @apply bg-black text-center text-white text-xs;
  font-family: '8bit', sans-serif;
  animation: fill-bar-animation linear 1s;
}
</style>
